import { render, staticRenderFns } from "./WarningList.vue?vue&type=template&id=4d7ab9e4&scoped=true&"
import script from "./WarningList.vue?vue&type=script&lang=js&"
export * from "./WarningList.vue?vue&type=script&lang=js&"
import style0 from "./WarningList.vue?vue&type=style&index=0&id=4d7ab9e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ab9e4",
  null
  
)

export default component.exports